import React, { useState } from "react";
import {
  Button,
  Card,
  CardImg,
  Row,
  Col,
  CardFooter,
  CardTitle,
} from "reactstrap";
import moment from "moment";
import PlusPackageVariantSelectModal from "../Modal/PlusPackageVariantSelectModal";
import AlertModal from "../Modal/AlertModal";
import { injectIntl } from "react-intl";
import { LicenseTypes } from "../../constants/LicenseTypes";
import RequestAplDemoPopover from "../Modal/RequestAplDemoPopover";

function AplProductItem({
  lastAddedProduct,
  handleOnAddPackage,
  enablePackage,
  product,
  currency,
  intl,
}) {
  const [selectForYearsModalIsOpen, setSelectForYearsModalIsOpen] =
    useState(false);
  const [selectedPlusPackage, setSelectedPlusPackage] = useState({});
  const [selectedPlusPackageVariant, setSelectedPlusPackageVariant] = useState({
    startDate: new Date(),
  });
  const [promptItemAlreadyInCart, setPromptItemAlreadyInCart] = useState(false);

  let validTo = moment(product.validTo).format("YYYY-MM-DD");
  let isValid = moment(validTo).isAfter();

  const handleAddOrSelectVariant = (item) => {
    let currentAplVariant = { name: "APL By LearnWARE", options: item.options };
    setSelectedPlusPackage({
      productVariant: currentAplVariant,
    });
    setSelectForYearsModalIsOpen(true);
  };

  const handleAddPackageWithYears = () => {
    //Sätt rätt pricestudent
    const itemToAdd = {
      name: selectedPlusPackageVariant.option.description,
      costCenter: product.fortNoxCostCenter,
      fortnoxNumber: selectedPlusPackageVariant.option.fortnoxNumber,
      programLicenseId: product.programLicenseId,
      priceStudent: selectedPlusPackageVariant.option.salesPrice,
      years: selectedPlusPackageVariant.option.years,
      startDate: selectedPlusPackageVariant.startDate,
      type: LicenseTypes.APLOnly,
      programName: product.programName,
    };
    handleOnAddPackage(itemToAdd);
    setSelectForYearsModalIsOpen(false);
  };

  const handleCloseselectForYearsModal = () => {
    setSelectedPlusPackageVariant({ startDate: new Date() });
    setSelectForYearsModalIsOpen(false);
  };

  const cardFooterOk = (
    <CardFooter className="pb-2 pt-0">
      <Row className="pt-2 px-0 d-flex">
        <Col lg="12" className="px-0">
          <Button
            title={intl.formatMessage({ id: "APLPackageStoreInfo" })}
            color="success"
            className="standard-btn"
            style={{ width: "100%", minHeight: "56px" }}
            onClick={() => handleAddOrSelectVariant(product)}
          >
            <Row style={{ justifyContent: "center" }}>
              <div style={{ display: "inline-block", paddingLeft: "1em" }}>
                {product.name}
              </div>
              <div
                style={{
                  display: "inline-block",
                  paddingLeft: ".8em",
                  paddingRight: ".8em",
                }}
              ></div>
            </Row>
          </Button>
        </Col>
      </Row>
      <Row className="pt-2 px-0 d-flex">
        <Col lg="12" className="px-0">
          <RequestAplDemoPopover width={"100%"} minHeight={"56px"} />
        </Col>
      </Row>
    </CardFooter>
  );

  return (
    <>
      <Card
        outline
        className={
          !isValid
            ? "bg-light m-0"
            : lastAddedProduct.fortnoxNumber !== product.fortnoxNumber
            ? "m-0"
            : "bg-success m-0"
        }
        title={
          !enablePackage
            ? intl.formatMessage({
                id: "OnlyAvailableForTeachersOnThisProgram",
              })
            : intl.formatMessage({
                id: "ClickChooseToStartCreatingStudentLicenses",
              })
        }
      >
        <CardImg
          top
          width="100%"
          src={"img/" + product.name + ".jpg"}
          alt="Card image cap"
          height= "160px"
        />
        <CardTitle
          className={"py-1 mb-0 text-center"}
          style={{ backgroundColor: "#E4E5E6" }}
        >
          <strong>Apl</strong>
        </CardTitle>
        {cardFooterOk}
      </Card>

      <PlusPackageVariantSelectModal
        isOpen={selectForYearsModalIsOpen}
        toggle={() => handleCloseselectForYearsModal()}
        selectedPlusPackageVariant={selectedPlusPackageVariant}
        setSelectedPlusPackageVariant={setSelectedPlusPackageVariant}
        selectedPlusPackage={selectedPlusPackage}
        setSelectForYearsModalIsOpen={setSelectForYearsModalIsOpen}
        handleAddPackageWithYears={handleAddPackageWithYears}
        currency={currency}
        isStandAloneApl={true}
      />
      <AlertModal
        close={() => setPromptItemAlreadyInCart(false)}
        isOpen={promptItemAlreadyInCart}
        title={intl.formatMessage({ id: "ProductIsAlreadyInCart" })}
        message={intl.formatMessage({
          id: "YouCanOnlyAddTheSameProductOnceInSameOrder",
        })}
      />
    </>
  );
}
export default injectIntl(AplProductItem);
